import axios from '../utils/axios';

export default async function getPaymentSyncCount (adminId, params) {
    return axios.get(`/admin/${adminId}/get-payment-sync-count`, { params });
}